var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",staticClass:"loading-overlay-parent"},[(_vm.active)?_c('div',{staticClass:"loading-overlay u-flex u-flex--horizontal-align"},[_c('spinner',{attrs:{"size":96}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }